// extracted by mini-css-extract-plugin
export default {"overlay":"Gw-z","bodyOpen":"Hw-z","content":"Iw-z","header":"Jw-z","close":"Kw-z","closeNoHeading":"Lw-z"};